import { Drawer } from "@mui/material";
import React from "react";
import { styled } from "styled-components";
import { Theme } from "../styles/Theme";

interface DrawerProps {
  children: React.ReactNode;
  open: boolean;
  onClose: () => void;
  styleVariant?: "pitch-info" | "sidebar" | "timeline" | "attribute" | "value-graph";
  customClassName?: string;
}

const StyledDrawer = styled(Drawer)<{ styleVariant: string }>`
  .MuiDrawer-paper {
    z-index: 99999;
    ${({ styleVariant, theme }) =>
      styleVariant === "pitch-info" &&
      `
          left: 60px;
          width: 284px;
          background: ${theme.playerContentBackground};
          box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
          z-index: 9999999;
        `}
    ${({ styleVariant, theme }) =>
      styleVariant === "attribute" &&
      `
          left: 60px;
          width: 620px;
          background: ${theme.playerContentBackground};
          box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
          z-index: 99999999;
        `}
        ${({ styleVariant, theme }) =>
      styleVariant === "timeline" &&
      `
          left: 60px;
          width: 728px;
          background: ${theme.playerContentBackground};
          box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
          z-index: 99999999;
        `}

        ${({ styleVariant, theme }) =>
      styleVariant === "sidebar" &&
      `
          left: 230px;
          width: 100vw; // 640px
          height: 100vh;
          // transition: all 200ms ease;
          background-color: transparent;
          backdrop-filter: blur(32px);
          & > div {
            position: sticky;
            top: 0;
            box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
            max-width: 640px;
            height: 100%;
            background: ${theme.playerContentBackground};
            transition: all 500ms ease;
            box-sizing: border-box;
          }
          @media(max-width: 1366px){
            left: 198px;
            box-shadow: none;
          }  
          @media(max-width: 1365px){
            left:222px;
            box-shadow: none;
          }    
          @media(max-width: 992px){
            left: 200px;
          }
         
        `}

        ${({ styleVariant, theme }) =>
      styleVariant === "value-graph" &&
      `
          left: 60px;
          width: calc(100% - 60px);
          background: ${theme.playerContentBackground};
          box-shadow: 8px 0px 16px 0px rgba(0, 0, 0, 0.15);
          z-index: 9999;
          height: 100vh;
          overflow: auto;
          z-index: 9999;
        `}
  }
`;

const DrawerComponent: React.FC<DrawerProps> = ({ children, open, onClose, styleVariant = "sidebar", customClassName }) => {
  return (
    <StyledDrawer className={customClassName} anchor="left" variant="persistent" styleVariant={styleVariant} open={open} onClose={onClose}>
      {children}
    </StyledDrawer>
  );
};

export default DrawerComponent;
